import React, { Component } from 'react';
import Team from './Team/Team';
import './TeamMembers.css';
import MentorImg from './mentor.png';
import Fade from 'react-reveal/Fade';
import { Dimensions } from '../../Helper/sitedimension';

const TeamMember = () => {
    const { width } = Dimensions.useWindowDimensions();
    return (
        <div className="teamMember">
            {width > 500 ?
                <div className="container-fluid bg-1">
                    <Fade delay={300}>
                        <h3 className="main">
                            <span className="con1">Our &nbsp;</span>
                            <span className="con3">Team  </span>
                        </h3>
                    </Fade>
                    <Fade delay={600}>
                        <h5 className="content">
                        With more than 7 plus years of experience in the area of Cyber Security and Cyber Forensics, Tapendra is an innovative thought leader responsible for strategizing, implementing and maturing Risk Management & Cybersecurity at Secure Blink.
                        He is an OSCP certified professional and has previously worked with the various government departments of India in the Cyber Security Field. Being an entrepreneur, Tapendra has built Secure Blink from ground up and has been a visionary and driving force behind its strategic plan, roadmap, methodology, organizational model, staffing, governance, and reporting.

                        </h5>
                    </Fade>
                    <Team className="class1" name="Tapendra Dev" position="Founder & CEO" src={MentorImg} />
                </div> :
                <div className="container-fluid bg-1 teammobile">
                    <Fade delay={300}>
                        <h3 className="maintm">
                            <span className="con1tm">Our &nbsp;</span>
                            <span className="con3tm">Team  </span>
                        </h3>
                    </Fade>
                    <Team className="class1tm" name="Tapendra Dev" position="Founder & CEO" src={MentorImg} />
                    <Fade delay={600}>
                        <h5 className="contenttm">
                        With more than 7 plus years of experience in the area of Cyber Security and Cyber Forensics, Tapendra is an innovative thought leader responsible for strategizing, implementing and maturing Risk Management & Cybersecurity at Secure Blink.

He is an OSCP certified professional and has previously worked with the various government departments of India in the Cyber Security Field. Being an entrepreneur, Tapendra has built Secure Blink from ground up and has been a visionary and driving force behind its strategic plan, roadmap, methodology, organizational model, staffing, governance, and reporting.

                        </h5>
                    </Fade>
                </div>
            }
        </div>
    )
}

export default TeamMember;